import { useEffect, useState } from "react";

const useFetchData = (
  get: (params?: any) => Promise<any>,
  set: (data: any) => void,
  params?: any,
) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const shouldFetch = params === undefined || params !== undefined;

    if (shouldFetch) {
      setIsLoaded(false);
      get(params)
        .then((result) => {
          if (Array.isArray(result)) {
            set(result);
          } else if (result && result.content) {
            set(result.content);
          } else {
            set([]);
          }
        })
        .catch((error) => {
          console.log("API Error:", error);
        })
        .finally(() => {
          setIsLoaded(true);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [get, JSON.stringify(params)]);

  return { isLoaded };
};

export default useFetchData;
